module.exports = __webpack_public_path__ + "static/media/seller2.706f2841.jpg";